import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    if (password.length < 6) {
      toast.error("Mínimo 6 caracteres");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full border border-neutral-300 px-4 py-3 outline-none focus:border-black bg-white text-sm";

  return (
    <div className="min-h-screen grid lg:grid-cols-2 font-sans">
      <div className="hidden lg:block relative bg-neutral-100">
        <img src="https://images.unsplash.com/photo-1618331833071-ce81bd50d300?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" alt="" className="absolute inset-0 w-full h-full object-cover" />
      </div>
      <div className="flex flex-col px-6 py-10 lg:px-16 lg:py-16">
        <Link to="/" className="overline text-neutral-500 hover:text-black flex items-center gap-2">
          <ArrowLeft size={14} /> d-Pod Gallery
        </Link>
        <div className="my-auto max-w-md w-full mx-auto">
          {!token ? (
            <div data-testid="reset-no-token">
              <h1 className="font-serif text-4xl font-light tracking-tight">Enlace inválido</h1>
              <p className="mt-4 text-sm text-neutral-500">No hemos encontrado un token en la URL. Solicita un nuevo enlace.</p>
              <Link to="/forgot-password" className="mt-8 inline-block bg-black text-white px-8 py-4 overline hover:bg-neutral-800 transition-colors">
                Solicitar enlace
              </Link>
            </div>
          ) : done ? (
            <div data-testid="reset-done">
              <CheckCircle2 size={48} strokeWidth={1} className="text-emerald-600" />
              <h1 className="font-serif text-4xl font-light tracking-tight mt-6">Contraseña actualizada</h1>
              <p className="mt-4 text-sm text-neutral-500">Te redirigimos al login...</p>
            </div>
          ) : (
            <>
              <h1 className="font-serif text-5xl font-light tracking-tight">Nueva contraseña</h1>
              <p className="mt-4 text-sm text-neutral-500">Elige una contraseña segura (mínimo 6 caracteres).</p>
              <form onSubmit={submit} className="mt-10 space-y-4" data-testid="reset-form">
                <input required type="password" minLength={6} placeholder="Nueva contraseña" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="reset-password" />
                <input required type="password" minLength={6} placeholder="Confirmar contraseña" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} data-testid="reset-confirm" />
                <button disabled={loading} type="submit" className="w-full bg-black text-white py-4 overline hover:bg-neutral-800 transition-colors disabled:opacity-50" data-testid="reset-submit">
                  {loading ? "..." : "Cambiar contraseña"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
